import { render, staticRenderFns } from "./BetterOfTheWeek.vue?vue&type=template&id=2992e8c1&"
import script from "./BetterOfTheWeek.vue?vue&type=script&lang=js&"
export * from "./BetterOfTheWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports